import {
    DTOCardFormField,
    FieldInCard,
} from 'app/types/form.types'
import {
    AdditionalFeesStatus,
    RangeType,
} from 'app/enums/label.enums'
import {
    AdditionalFeeValue,
} from '../AdditionalFee.types'

type FeesData = {
    ccy?: string,
    originalStatus?: string,
}
type Params = FeesData & {
    fees: {
        id: number,
    }[],
    exists: boolean,
    originalStatus?: string,
    editingAllowed: boolean,
    editingCommentAllowed: boolean,
    getAllowedValues: (param: Record<string, any>) => Record<string, string>
}

type AdditionalFeesFormFields = keyof AdditionalFeeValue

const additionalFeeComponents = ({
    ccy,
    fees,
    exists,
    originalStatus,
    editingAllowed,
    editingCommentAllowed,
    getAllowedValues,
}: Params) => {
    const feesRow: FieldInCard<AdditionalFeesFormFields> = {
        title: 'Fees',
        className: 'fees',
        fields: [{
            name: 'fees',
            componentName: 'Fees',
            currency: ccy,
            value: fees,
            disabled: editingAllowed,
            showSkyNetSpreadSheet: true,
            labelKey: 'FEES',
        }],
    }

    const defaultFields: DTOCardFormField<AdditionalFeesFormFields>[] = [{
        title: 'General',
        classNames: ({
            general,
        }) => {
            return {
                gridCardWrapper: general,
            }
        },
        fields: [
            {
                name: 'additionalFeesStatus',
                originalStatus,
                componentName: 'StatusTransitionSelector',
                useDropdown: true,
                allowedValues: getAllowedValues(AdditionalFeesStatus),
                disabled: true,
                labelKey: 'STATUS',
                className: 'status',
            },
            {
                name: 'validFrom',
                componentName: 'DateSelect',
                disabled: editingAllowed,
                required: true,
                labelKey: 'VALID_FROM',
                className: 'validFrom',
            },
            {
                name: 'validTo',
                componentName: 'DateSelect',
                disabled: editingAllowed,
                required: true,
                labelKey: 'VALID_TO',
                className: 'validTo',
            },
            {
                name: 'requiresManualBillingReview',
                componentName: 'Checkbox',
                disabled: editingAllowed,
                labelKey: 'REQUIRES_MANUAL_BILLING_REVIEW',
                className: 'manualBillingReview',
            },
            {
                name: 'cancellationFeeTimeline',
                componentName: 'IntegerInput',
                disabled: editingAllowed,
                required: true,
                labelKey: 'CANCELLATION_DAYS',
                className: 'cancellationDays',
            },
            {
                name: 'cancellationDaysType',
                componentName: 'EnumSelector',
                allowedValues: getAllowedValues(RangeType),
                useDropdown: true,
                disabled: editingAllowed,
                required: true,
                labelKey: 'CANCELLATION_DAYS_TYPE',
                className: 'cancellationDaysType',
            },
            {
                name: 'comment',
                componentName: 'LongText',
                disabled: editingCommentAllowed && editingAllowed,
                labelKey: 'COMMENT',
                className: 'comment',
            },
        ],
    }]

    return exists ? [
        ...defaultFields,
        feesRow,
    ] : defaultFields
}

export default additionalFeeComponents
